import React, { Component, Fragment } from "react";
import Footer1 from "../directives/footer1";
import Header1 from "../directives/header1";
import axios from "axios";
import config from "../config/config";
import Cookies from "js-cookie";
import { getCurrentProvider } from "../components/provider";
import Web3 from "web3";
import { Fade, Zoom, Bounce } from "react-reveal";
import Slider from "react-slick";
import { Dialog, Classes } from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";
import BarLoader from "react-bar-loader";
import { CopyToClipboard } from "react-copy-to-clipboard";
import moment from "moment";
import Popup from "../popup";
import { Helmet } from "react-helmet";
import Countdown, { zeroPad } from "react-countdown";
import { toast } from "react-toastify";
import { Player } from "video-react";
import Swal from "sweetalert2";

// -----------
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import SocialShare from "./socialShare";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
const MAX_LENGTH = 520;
const MAX_LENGTH_DESC = 150;


export default class itemactivity extends Component {
  constructor(props) {
    super(props);

    this.state = {
      thumbsSwiper: null,
    };

    const {
      match: { params },
    } = this.props;
    this.itemId = params.itemId;
    this.type = params.type;
    this.loginData = !Cookies.get("artfungibleUserloginSuccess")
      ? []
      : JSON.parse(Cookies.get("artfungibleUserloginSuccess"));
    this.state = {
      listSingleItemData: "",
      collectionList: [],
      agreed: false,
      setOpen: false,
      bidPrice: "",
      multipleDigImages: [],
      multiplePhyImages: [],
      liveCryptoPrice: [],
      itemActivityData: [],
      getCollectionDetailByArtistIdData: [],
      isDialogOpen: false,
      isPopupError: false,
      isPopupSuccess: false,
      msg: false,
      latestBidData: [],
      latestOwner: [],
      expData1: "",
      seoList: "",
      newDateData: "",
      shippingAddressData: "",
      shareShowData: false,
    };

    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = ("0" + (currentDate.getMonth() + 1)).slice(-2);
    const day = ("0" + currentDate.getDate()).slice(-2);
    const hours = ("0" + currentDate.getHours()).slice(-2);
    const minutes = ("0" + currentDate.getMinutes()).slice(-2);
    const seconds = ("0" + currentDate.getSeconds()).slice(-2);

    const formattedDate = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

    setTimeout(() => {
      this.setState({
        newDateData: formattedDate,
      });
    });
  }

  setThumbsSwiper = (swiper) => {
    this.setState({ thumbsSwiper: swiper });
  };

  componentDidMount() {
    // const receivedData = this.props.location.state;
    // console.log("receivedData.state", receivedData.state);

    var url = window.location.href;
    var split = url.split("/");
    let lastSecondSegment = split[split.length - 2];
    this.getSeoAPI(lastSecondSegment);

    let lastFirstSegment = split[split.length - 1];
    console.log("lastFirstSegment", lastFirstSegment);
    const result = lastFirstSegment.replace(/-/g, " ");
    console.log(result);
    console.log(lastFirstSegment);
    this.getDigitalItem(result, lastFirstSegment);
    this.getPhysicalItem(result, lastFirstSegment);

    // if (receivedData) {
    //   this.itemId = receivedData.state.itemId;
    //   this.type = receivedData.state.type;
    // } else {
    // }

    this.itemViewAction();
    // this.livePriceAPI();

    setInterval(() => {
      if (this.state.shippingAddressData?.shippingAddress === undefined) {
        this.getshippingAddressAPI();
      }
    }, 2000);
  }

  async getDigitalItem(result, lastFirstSegment) {
    try {
      await axios({
        method: "get",
        url: `${config.apiUrl}listitemUser`,
        headers: { Authorization: this.loginData.Token },
      }).then((response) => {
        if (response.data.success === true) {
          let _getListItemAPIData = [];

          // response.data.response.map((item) => {
          //   const timezoneOffset = new Date().getTimezoneOffset() * -1;

          //   let newDate = new Date(item.expiry_date);
          //   let stDate = new Date(item.start_date1);

          //   newDate.setMinutes(newDate.getMinutes() + timezoneOffset);
          //   item.expiry_date = moment(newDate).format("YYYY-MM-DD HH:mm:SS"); // Add the modified date to the item
          //   item.start_date1 = moment(stDate).format("YYYY-MM-DD HH:mm:SS"); // Add the modified date to the item

          //   if (
          //     item.firstPurchase == 1 &&
          //     item.removeFromMarketPlace == 0 &&
          //     item.item_collection_id ==
          //       this.state.listSingleItemData.item_collection_id
          //   ) {
          //     _getListItemAPIData.push(item);
          //   }
          // });
          let allData = response.data.response.filter(
            (item) => item.name == result || item.name == lastFirstSegment
          );
          this.itemId = allData[0].id;
          console.log("eeeeeeeeeee", this.itemId);
          this.type = 1;
          this.getItemDetailAction();
          this.digitalMultipleImagesAction();
          this.getProductsbidsAPIAction();
        } else {
          this.setState({});
        }
      });
    } catch (err) {
      this.setState({});
    }
  }

  async getPhysicalItem(result, lastFirstSegment) {
    console.log("lastFirstSegment11111", result);
    try {
      await axios({
        method: "get",
        url: `${config.apiUrl}listitemAllUserPhysical`,
        headers: { Authorization: this.loginData.Token },
      }).then((response) => {
        if (response.data.success === true) {
          let _getListItemAPIData = [];

          // response.data.response.map((item) => {
          //   const timezoneOffset = new Date().getTimezoneOffset() * -1;

          //   let newDate = new Date(item.expiry_date);
          //   let stDate = new Date(item.start_date1);

          //   newDate.setMinutes(newDate.getMinutes() + timezoneOffset);
          //   item.expiry_date = moment(newDate).format("YYYY-MM-DD HH:mm:SS"); // Add the modified date to the item
          //   item.start_date1 = moment(stDate).format("YYYY-MM-DD HH:mm:SS"); // Add the modified date to the item

          //   if (
          //     item.firstPurchase == 1 &&
          //     item.removeFromMarketPlace == 0 &&
          //     item.item_collection_id ==
          //       this.state.listSingleItemData.item_collection_id
          //   ) {
          //     _getListItemAPIData.push(item);
          //   }
          // });
          console.log("response.data.response", response.data.response);
          let allData = response.data.response.filter(
            (item) => item.name == result || item.name == lastFirstSegment
          );
          console.log("allData", allData);
          this.itemId = allData[0].id;
          this.type = 2;

          this.getItemDetailActionPhysical();
          this.physicalMultipleImagesPhysical();
          this.getProductsbidsAPIAction();
        } else {
        }
      });
    } catch (err) {
      this.setState({});
    }
  }

  async digitalMultipleImagesAction() {
    try {
      await axios({
        method: "post",
        url: `${config.apiUrl}digitalMultipleImages`,
        headers: { Authorization: this.loginData.Token },
        data: {
          item_id: this.itemId,
        },
      }).then((response) => {
        if (response.data.success === true) {
          this.setState({
            multipleDigImages: response.data.response,
          });
        } else {
        }
      });
    } catch (err) {}
  }

  async physicalMultipleImagesPhysical() {
    try {
      await axios({
        method: "post",
        url: `${config.apiUrl}physicalMultipleImages`,
        headers: { Authorization: this.loginData.Token },
        data: {
          item_id: this.itemId,
        },
      }).then((response) => {
        if (response.data.success === true) {
          this.setState({
            multipleDigImages: response.data.response,
          });
        } else {
        }
      });
    } catch (err) {}
  }

  handleCheckboxChange = () => {
    this.setState({ agreed: !this.state.agreed });
  };

  async onOpenModal() {
    this.setState({
      setOpen: true,
    });
  }
  async onCloseModal() {
    this.setState({
      setOpen: false,
      agreed: false,
    });
  }

  async getshippingAddressAPI() {
    try {
      await axios({
        method: "post",
        url: `${config.apiUrl}userShippingAddress`,
        data: { userId: this.loginData.data.id },
        headers: { Authorization: this.loginData.Token },
      }).then((response) => {
        if (response.data.success === true) {
          this.setState({
            shippingAddressData: response.data,
          });
        } else {
          this.setState({
            shippingAddressData: "",
          });
        }
      });
    } catch (err) {
      this.setState({
        shippingAddressData: "",
      });
    }
  }

  async getSeoAPI(lastSecondSegment) {
    await axios({
      method: "post",
      url: `${config.apiUrl}/getSEO`,
      data: { pageName: lastSecondSegment },
    })
      .then(async (response) => {
        if (response.data.success === true) {
          this.setState({
            seoList: response.data.data,
          });
        } else if (response.data.success === false) {
        }
      })
      .catch((err) => {});
  }

  async getItemDetailAction() {
    try {
      await axios({
        method: "post",
        url: `${config.apiUrl}listSingleItem`,
        data: {
          item_id: this.itemId,
          user_id: this.loginData?.data?.id ? this.loginData?.data?.id : "0",
        },
      }).then((response) => {
        if (response.data.success === true) {
          const timezoneOffset = new Date().getTimezoneOffset();

          let newDate = new Date(response.data.response.expiry_date1);
          newDate.setMinutes(newDate.getMinutes() - timezoneOffset);
          let expiry_date1 = moment(newDate).format("YYYY-MM-DD HH:mm:SS"); // Add the modified date to the ite

          this.setState({
            expData1: expiry_date1,
          });
          this.setState({
            listSingleItemData: response.data.response,
          });

          this.getCollectionDetailByArtistIdAction(response.data.response);
          this.getCollectionDetailByArtistIdActionColl(response.data.response);
        } else {
          this.setState({
            listSingleItemData: "",
          });
        }
      });
    } catch (err) {
      this.setState({
        listSingleItemData: "",
      });
    }
  }

  async getItemDetailActionPhysical() {
    try {
      await axios({
        method: "post",
        url: `${config.apiUrl}listSingleItemPhysical`,
        data: {
          item_id: this.itemId,
          user_id: this.loginData?.data?.id ? this.loginData?.data?.id : "0",
        },
      }).then((response) => {
        if (response.data.success === true) {
          const timezoneOffset = new Date().getTimezoneOffset();

          let newDate = new Date(response.data.response.expiry_date1);
          newDate.setMinutes(newDate.getMinutes() - timezoneOffset);
          let expiry_date1 = moment(newDate).format("YYYY-MM-DD HH:mm:SS"); // Add the modified date to the ite

          this.setState({
            expData1: expiry_date1,
          });
          this.setState({
            listSingleItemData: response.data.response,
          });

          this.getCollectionDetailByArtistIdAction(response.data.response);
          this.getCollectionDetailByArtistIdActionColl(response.data.response);
        } else {
          this.setState({
            listSingleItemData: "",
          });
        }
      });
    } catch (err) {
      this.setState({
        listSingleItemData: "",
      });
    }
  }

  async buyNft(e) {
    e.preventDefault();
    const rpcUrl =
      this.state.listSingleItemData.artistType == 1
        ? config.baseRpcUrl
        : config.ethRpcUrl;
    console.log("this.loginData.length", this.loginData.length);
    if (this.loginData.length === 0) {
      this.setState({
        isPopupError: true,
        msg: "Connect Wallet First",
      });
      setTimeout(() => {
        this.setState({
          isPopupError: false,
        });
      }, 8000);
      return;
    } else if (
      this.type == 2 &&
      this.state.shippingAddressData?.shippingAddress == ""
    ) {
      window.location.href = `${config.baseUrl}setting`;
    } else if (this.state.listSingleItemData.artistType == 0) {
      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: Web3.utils.toHex(config.chainIdTx) }],
        });
      } catch (switchError) {
        if (switchError.code === 4902) {
          try {
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: Web3.utils.toHex(config.chainIdTx),
                  chainName: "ETH",
                  rpcUrls: [`${rpcUrl}`],
                  nativeCurrency: {
                    name: "ETH",
                    symbol: "ETH",
                    decimals: 18,
                  },
                  blockExplorerUrls: ["https://etherscan.io/"],
                },
              ],
            });
          } catch (addError) {}
        }
      }
    } else if (this.state.listSingleItemData.artistType == 1) {
      try {
        await window.ethereum.request({
          method: "wallet_switchEthereumChain",
          params: [{ chainId: Web3.utils.toHex(config.chainIdSepTx) }],
        });
      } catch (switchError) {
        if (switchError.code === 4902) {
          try {
            await window.ethereum.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: Web3.utils.toHex(config.chainIdSepTx),
                  chainName: "Base Sepolia",
                  rpcUrls: [`${rpcUrl}`],
                  nativeCurrency: {
                    name: "ETH",
                    symbol: "ETH",
                    decimals: 18,
                  },
                  blockExplorerUrls: ["https://etherscan.io/"],
                },
              ],
            });
          } catch (addError) {}
        }
      }
    }
    try {
      const providers = await getCurrentProvider();
      const web3 = new Web3(providers);

      let tokenId = this.state.listSingleItemData.token_id;
      let contractAddres = this.state.listSingleItemData.contract;
      let marketplaceContractObject = new web3.eth.Contract(
        this.type == 2
          ? config.abiplacePhysicalMarketplace
          : config.abiMarketplace,
        this.type == 2
          ? config.marketplacePhysicalContract
          : this.state.listSingleItemData.artistType == 1
          ? config.marketplaceContractBase
          : config.marketplaceContract
      );
      let getTokenDetails = await marketplaceContractObject.methods
        .getTokenDetails(contractAddres, tokenId)
        .call();
      let returnAmountApi = false;
      if (
        getTokenDetails.lastBidder !=
        "0x0000000000000000000000000000000000000000"
      ) {
        returnAmountApi = true;
      }
      let price = getTokenDetails.price;

      if (getTokenDetails.saleType == 2) {
        if (this.state.bidPrice <= 0) {
          this.setState({
            isPopupError: true,
            msg: "Invalid Amount !!",
          });
          setTimeout(() => {
            this.setState({
              isPopupError: false,
            });
          }, 8000);
          return;
        }
        price = parseInt(this.state.bidPrice * 10 ** 18).toString();
        if (
          price <= getTokenDetails.price &&
          price <= getTokenDetails.lastBid
        ) {
          this.setState({
            isPopupError: true,
            msg: "Amount should be greater than last bid !!",
          });
          setTimeout(() => {
            this.setState({
              isPopupError: false,
            });
          }, 8000);

          return;
        }
      }
      let userAddress = this.loginData.data.walletAddress;
      let userBalance = await web3.eth.getBalance(userAddress);

      if (parseInt(userBalance) / 10 ** 18 < parseInt(price) / 10 ** 18) {
        this.setState({
          isPopupError: true,
          msg: "Insufficient fund",
        });
        setTimeout(() => {
          this.setState({
            isPopupError: false,
          });
        }, 8000);
        return;
      }

      let BuyNft = await marketplaceContractObject.methods.BuyNft(
        contractAddres,
        tokenId
      );
      this.setState({
        isDialogOpen: true,
      });
      let encoded_tx = BuyNft.encodeABI();

      let gasPrice = await web3.eth.getGasPrice();

      let gasLimit = await web3.eth.estimateGas({
        gasPrice: web3.utils.toHex(gasPrice),
        to:
          this.type == 2
            ? config.marketplacePhysicalContract
            : this.state.listSingleItemData.artistType == 1
            ? config.marketplaceContractBase
            : config.marketplaceContract,
        from: userAddress,
        data: encoded_tx,
        value: price,
      });

      let trx = await web3.eth.sendTransaction({
        gasPrice: web3.utils.toHex(gasPrice),
        gas: web3.utils.toHex(gasLimit),
        to:
          this.type == 2
            ? config.marketplacePhysicalContract
            : this.state.listSingleItemData.artistType == 1
            ? config.marketplaceContractBase
            : config.marketplaceContract,
        from: userAddress,
        data: encoded_tx,
        value: price,
      });
      if (trx.transactionHash) {
        this.setState({
          isPopupSuccess: true,
          msg:
            getTokenDetails.saleType == 2
              ? "Bid Applied Successfully"
              : "Purchased Successfully",
        });
        setTimeout(() => {
          this.setState({
            isPopupSuccess: false,
          });
        }, 8000);
        this.setState({
          isDialogOpen: false,
        });
        setTimeout(() => {
          window.location.href = `${config.baseUrl}membership/${this.loginData.data.walletAddress}`;
        }, 2000);
      }
    } catch (err) {
      console.log('errrrrr',err)
      if (err.message.toString().split("insufficient funds")[1]) {
        this.setState({
          isPopupError: true,
          msg: "Transaction reverted : " + err.message,
        });
        setTimeout(() => {
          this.setState({
            isPopupError: false,
          });
        }, 8000);
      } else {
        this.setState({
          isDialogOpen: false,
        });
        if (err.toString().split("execution reverted:")[1]) {
          this.setState({
            isPopupError: true,
            msg:
              "Transaction reverted : " +
              err
                .toString()
                .split("execution reverted:")[1]
                .toString()
                .split("{")[0],
          });
          setTimeout(() => {
            this.setState({
              isPopupError: false,
            });
          }, 8000);
        } else {
          this.setState({
            isDialogOpen: false,
          });
          this.setState({
            isPopupError: true,
            msg: err.message,
          });
          setTimeout(() => {
            this.setState({
              isPopupError: false,
            });
          }, 8000);
        }
      }
      this.setState({
        spinLoader: "0",
        isDialogOpen: false,
      });
      return false;
    }
  }

  async cancelListing(e) {
    e.preventDefault();
    if (this.loginData.length === 0) {
      this.setState({
        isPopupError: true,
        msg: "Connect Wallet First",
      });
      setTimeout(() => {
        this.setState({
          isPopupError: false,
        });
      }, 8000);
    } else {
      // alert('1')
      try {
        const rpcUrl =
          this.state.listSingleItemData.artistType == 1
            ? config.baseRpcUrl
            : config.ethRpcUrl;

        if (this.state.listSingleItemData.artistType == 1) {
          try {
            await window.ethereum.request({
              method: "wallet_switchEthereumChain",
              params: [{ chainId: Web3.utils.toHex(config.chainIdSepTx) }],
            });
          } catch (switchError) {
            if (switchError.code === 4902) {
              try {
                await window.ethereum.request({
                  method: "wallet_addEthereumChain",
                  params: [
                    {
                      chainId: Web3.utils.toHex(config.chainIdSepTx),
                      chainName: "Base Sepolia",
                      rpcUrls: [`${rpcUrl}`],
                      nativeCurrency: {
                        name: "ETH",
                        symbol: "ETH",
                        decimals: 18,
                      },
                      blockExplorerUrls: [
                        "https://base-sepolia.blockscout.com",
                      ],
                    },
                  ],
                });
              } catch (addError) {}
            }
          }
        } else {
          try {
            await window.ethereum.request({
              method: "wallet_switchEthereumChain",
              params: [{ chainId: Web3.utils.toHex(config.chainIdTx) }],
            });
          } catch (switchError) {
            if (switchError.code === 4902) {
              try {
                await window.ethereum.request({
                  method: "wallet_addEthereumChain",
                  params: [
                    {
                      chainId: Web3.utils.toHex(config.chainIdTx),
                      chainName: "ETH",
                      rpcUrls: [`${rpcUrl}`],
                      nativeCurrency: {
                        name: "ETH",
                        symbol: "ETH",
                        decimals: 18,
                      },
                      blockExplorerUrls: [
                        "https://base-sepolia.blockscout.com",
                      ],
                    },
                  ],
                });
              } catch (addError) {}
            }
          }
        }

        let userAddress = this.loginData.data.walletAddress;
        const providers = await getCurrentProvider();
        const web3 = new Web3(providers);

        let tokenId = this.state.listSingleItemData.token_id;
        let contractAddres = this.state.listSingleItemData.contract;

        let marketplaceContractObject = new web3.eth.Contract(
          this.type == 2
            ? config.abiplacePhysicalMarketplace
            : config.abiMarketplace,
          this.type == 2
            ? config.marketplacePhysicalContract
            : this.state.listSingleItemData.artistType == 1
            ? config.marketplaceContractBase
            : config.marketplaceContract
        );
        let getTokenDetails = await marketplaceContractObject.methods
          .getTokenDetails(contractAddres, tokenId)
          .call();

        if (
          getTokenDetails.lastBidder !=
          "0x0000000000000000000000000000000000000000"
        ) {
          alert(
            "Someone is already bid on this NFT please accept or reject it!!"
          );
          return;
        }
        let price = getTokenDetails.price;
        // if (getTokenDetails.saleType == 1) {
        let RemoveNftFromSale =
          await marketplaceContractObject.methods.removeNftFromSale(
            contractAddres,
            tokenId.toString()
          );

        this.setState({
          isDialogOpen: true,
        });
        let encoded_tx = RemoveNftFromSale.encodeABI();

        let gasPrice = await web3.eth.getGasPrice();

        let gasLimit = await web3.eth.estimateGas({
          gasPrice: web3.utils.toHex(gasPrice),
          to:
            this.type == 2
              ? config.marketplacePhysicalContract
              : this.state.listSingleItemData.artistType == 1
              ? config.marketplaceContractBase
              : config.marketplaceContract,
          from: userAddress,
          data: encoded_tx,
          // value: price,
        });
        let trx = await web3.eth.sendTransaction({
          gasPrice: web3.utils.toHex(gasPrice),
          gas: web3.utils.toHex(gasLimit),
          to:
            this.type == 2
              ? config.marketplacePhysicalContract
              : this.state.listSingleItemData.artistType == 1
              ? config.marketplaceContractBase
              : config.marketplaceContract,
          from: userAddress,
          data: encoded_tx,
          //value: price,
        });
        if (trx.transactionHash) {
          this.setState({
            isPopupSuccess: true,
            msg: "Nft will be Unlist shortly",
          });
          setTimeout(() => {
            this.setState({
              isPopupSuccess: false,
            });
          }, 8000);
          this.setState({
            isDialogOpen: false,
          });
          setTimeout(() => {
            window.location.href = `${config.baseUrl}membership/${this.loginData.data.walletAddress}`;
          }, 2000);
        }
      } catch (err) {
        if (err.message.toString().split("insufficient funds")[1]) {
          this.setState({
            isPopupError: true,
            msg: "Transaction reverted : " + err.message,
          });
          setTimeout(() => {
            this.setState({
              isPopupError: false,
            });
          }, 8000);
        } else {
          this.setState({
            isDialogOpen: false,
          });
          if (err.toString().split("execution reverted:")[1]) {
            this.setState({
              isPopupError: true,
              msg:
                "Transaction reverted : " +
                err
                  .toString()
                  .split("execution reverted:")[1]
                  .toString()
                  .split("{")[0],
            });
            setTimeout(() => {
              this.setState({
                isPopupError: false,
              });
            }, 8000);
          } else {
            this.setState({
              isDialogOpen: false,
            });
            this.setState({
              isPopupError: true,
              msg: err.message,
            });
            setTimeout(() => {
              this.setState({
                isPopupError: false,
              });
            }, 8000);
          }
        }
        this.setState({
          spinLoader: "0",
          isDialogOpen: false,
        });
        return false;
      }
    }
  }

  async removeNFTFromSaleApi(hash, contractAddres, tokenId) {
    try {
      this.setState({
        isDialogOpen: true,
      });
      let dataa = {
        contract: contractAddres,
        user_id: this.loginData.data.id,
        item_id: this.state.listSingleItemData.itemId,
        trx_currency:
          this.state.listSingleItemData.artistType == 0
            ? config.currencyType
            : config.currencyTypeSep,
        owner: this.loginData.data.first_name,
        transactionHash: hash,
        tokenId: this.state.listSingleItemData.token_id,
        trx_type: 1,
        cryptoPrice: 0,
        itemName: this.state.listSingleItemData.token_id.name,
        owner_id: this.loginData.data.id,
      };

      await axios({
        method: "post",
        url: `${
          this.type == 1
            ? config.apiUrl + "removeNFTFromSale"
            : config.apiUrl + "removeNFTFromSalePhysical"
        }`,
        headers: { Authorization: this.loginData.Token },
        data: dataa,
      }).then((response) => {
        if (response.data.success === true) {
          this.setState({
            isPopupSuccess: true,
            msg: response.data.msg,
          });
          setTimeout(() => {
            this.setState({
              isPopupSuccess: false,
            });
          }, 8000);
          this.setState({
            isDialogOpen: false,
          });
          setTimeout(() => {
            window.location.href = `${config.baseUrl}membership/${this.loginData.data.walletAddress}`;
          }, 2000);
        } else {
          this.setState({
            isPopupError: true,
            msg: response.data.msg,
          });
          setTimeout(() => {
            this.setState({
              isPopupError: false,
            });
          }, 8000);
          this.setState({});
        }
      });
    } catch (err) {
      this.setState({
        isDialogOpen: false,
      });
    }
  }

  changeBidPrice(e) {
    this.setState({ bidPrice: e.target.value });
  }

  async itemViewAction() {
    try {
      await axios({
        method: "post",
        url: `${config.apiUrl}itemView`,
        headers: { Authorization: this.loginData.Token },
        data: {
          user_id: this.loginData.data.id,
          item_id: this.itemId,
        },
      }).then((response) => {
        if (response.data.success === true) {
        } else {
        }
      });
    } catch (err) {}
  }

  async itemLikedAction() {
    try {
      await axios({
        method: "post",
        url: `${config.apiUrl}itemLike`,
        headers: { Authorization: this.loginData.Token },
        data: {
          user_id: this.loginData.data.id,
          item_id: this.itemId,
        },
      }).then((response) => {
        if (response.data.success === true) {
          this.getItemDetailAction();
        } else {
        }
      });
    } catch (err) {}
  }

  async WishListAction() {
    if (this.loginData.length === 0) {
      this.setState({
        isPopupError: true,
        msg: "Connect Wallet First",
      });
      setTimeout(() => {
        this.setState({
          isPopupError: false,
        });
      }, 8000);
    } else {
      try {
        await axios({
          method: "post",
          url: `${
            this.type == 1
              ? config.apiUrl + "addWishlist"
              : config.apiUrl + "addWishlistPhysical"
          }`,
          headers: { Authorization: this.loginData.Token },
          data: {
            user_id: this.loginData.data.id,
            item_id: this.itemId,
          },
        }).then((response) => {
          if (response.data.success === true) {
            this.setState({
              isPopupSuccess: true,
              msg: response.data.msg,
            });
            setTimeout(() => {
              this.setState({
                isPopupSuccess: false,
              });
            }, 8000);
            this.getItemDetailAction();
          } else {
            this.setState({
              isPopupError: true,
              msg: response.data.msg,
            });
            setTimeout(() => {
              this.setState({
                isPopupError: false,
              });
            }, 8000);
          }
        });
      } catch (err) {}
    }
  }

  async getProductsbidsAPIAction() {
    try {
      await axios({
        method: "post",
        url: `${config.apiUrl}getProductsbidsAPI`,
        headers: { Authorization: this.loginData.Token },
        data: {
          item_id: this.itemId,
          nft_type: this.type,
        },
      }).then((response) => {
        if (response.data.success === true) {
          this.setState({
            itemActivityData: response.data.data,
            latestBidData: response.data.data.filter(
              (item) => item.nft_activity_type === "Bid"
            ),
            latestOwner: response.data.data.filter(
              (item) =>
                item.nft_activity_type === "Purchase" ||
                item.nft_activity_type === "Resale" ||
                item.nft_activity_type === "Bid Accepted"
            ),
          });
        } else {
        }
      });
    } catch (err) {
      // alert('45')
    }
  }

  collectionLinkFeat = async (item, typeData) => {
    const formattedCreatorName = item.creatorName.replace(/\s+/g, "-"); // Replaces spaces with hyphens
    const formattedCollectionName = item.collectionName.replace(/\s+/g, "-"); // Replaces spaces with hyphens
    const formattedArtworkName = item.name.replace(/\s+/g, "-"); // Replaces spaces with hyphens
    this.type = typeData;
    this.props.history.push(
      `${config.baseUrl}${formattedCreatorName}/${formattedCollectionName}/${formattedArtworkName}`,
      {
        state: { itemId: item.id, type: typeData },
      }
    );

    setTimeout(() => {
      window.location.reload();
    }, 1000);
  };

  async getCollectionDetailByArtistIdAction(artistId) {
    try {
      await axios({
        method: "get",
        url:
          this.type == 1
            ? `${config.apiUrl}listitemUser`
            : `${config.apiUrl}listitemUserPhysical`,
        headers: { Authorization: this.loginData.Token },
      }).then((response) => {
        if (response.data.success === true) {
          let _getListItemAPIData = [];

          response.data.response.map((item) => {
            const timezoneOffset = new Date().getTimezoneOffset() * -1;

            let newDate = new Date(item.expiry_date);
            let stDate = new Date(item.start_date1);

            newDate.setMinutes(newDate.getMinutes() + timezoneOffset);
            item.expiry_date = moment(newDate).format("YYYY-MM-DD HH:mm:SS"); // Add the modified date to the item
            item.start_date1 = moment(stDate).format("YYYY-MM-DD HH:mm:SS"); // Add the modified date to the item

            if (
              item.firstPurchase == 1 &&
              item.removeFromMarketPlace == 0 &&
              item.item_collection_id ==
                this.state.listSingleItemData.item_collection_id
            ) {
              _getListItemAPIData.push(item);
            }
          });

          this.setState({
            getListItemAPIData: _getListItemAPIData,
          });
        } else {
        }
      });
    } catch (err) {}
  }

  async getCollectionDetailByArtistIdActionColl(artistId) {
    try {
      await axios({
        method: "get",
        url:
          this.type == 1
            ? `${config.apiUrl}listitemUser`
            : `${config.apiUrl}listitemUserPhysical`,
        headers: { Authorization: this.loginData.Token },
      }).then((response) => {
        if (response.data.success === true) {
          let _getListItemAPIData = [];

          response.data.response.map((item) => {
            const timezoneOffset = new Date().getTimezoneOffset() * -1;

            let newDate = new Date(item.expiry_date);
            let stDate = new Date(item.start_date1);

            newDate.setMinutes(newDate.getMinutes() + timezoneOffset);
            item.expiry_date = moment(newDate).format("YYYY-MM-DD HH:mm:SS"); // Add the modified date to the item
            item.start_date1 = moment(stDate).format("YYYY-MM-DD HH:mm:SS"); // Add the modified date to the item

            if (
              item.firstPurchase == 0 &&
              item.removeFromMarketPlace == 0 &&
              item.item_collection_id ==
                this.state.listSingleItemData.item_collection_id
            ) {
              _getListItemAPIData.push(item);
            }
          });

          this.setState({
            getCollectionDetailByArtistIdData: _getListItemAPIData,
          });
        } else {
          this.setState({
            getCollectionDetailByArtistIdData: [],
          });
        }
      });
    } catch (err) {
      this.setState({
        getCollectionDetailByArtistIdData: [],
      });
    }
  }

  livePriceAPI = async () => {
    await axios({
      method: "get",
      url: "https://api.coingecko.com/api/v3/coins/markets?vs_currency=USD&ids=ethereum&order=market_cap_desc&per_page=100&page=1&sparkline=false",
    }).then((response) => {
      this.setState({
        liveCryptoPrice: response.data,
      });
    });
  };

  copieBtn = async () => {
    this.setState({
      isPopupSuccess: true,
      msg: "copied",
    });
    setTimeout(() => {
      this.setState({
        isPopupSuccess: false,
      });
    }, 8000);
  };

  getTimeOfStartDate(dateTime) {
    var date = new Date(dateTime); // some mock date
    var milliseconds = date.getTime();
    return milliseconds;
  }

  CountdownTimer({ days, hours, minutes, seconds, completed }) {
    if (completed) {
      // Render a completed state
      return "Starting";
    } else {
      // Render a countdowns
      var dayPrint = days > 0 ? days + "d" : "";
      return (
        <span>
          {dayPrint} {zeroPad(hours)}h {zeroPad(minutes)}m {zeroPad(seconds)}s
        </span>
      );
    }
  }

  collectionLink = async (item) => {
    const formattedName = item.name.replace(/\s+/g, "-"); // Replaces spaces with hyphens
    const formattedCollectionName = item.collectionName.replace(/\s+/g, "-"); // Replaces spaces with hyphens
    this.props.history.push(
      `${config.baseUrl}${formattedName}/${formattedCollectionName}`,
      {
        state: { collectionId: item.collectionId },
      }
    );
  };

  artistLink = async (item) => {
    const formattedName = item.creatorName.replace(/\s+/g, "-"); // Replaces spaces with hyphens

    this.props.history.push(`${config.baseUrl}${formattedName}`, {
      state: { artistId: item.creator },
    });
  };

  shareShow = async (item) => {
    this.setState({
      shareShowData: true,
    });
  };

  async mint(e, item, type) {
    e.preventDefault();
    if (this.loginData.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Oops",
        text: "Please connect wallet!!",
      });
      return;
    }
    if (type == 2) {
      if (this.state.shippingAddressData?.shippingAddress == "") {
        window.location.href = `${config.baseUrl}setting`;
      }
    }

    this.setState({
      nfttype: type,
    });
    try {
      const providers = await getCurrentProvider();
      const web3 = new Web3(providers);
      var currentNetwork = web3.currentProvider.chainId;

      let artistTypeData = item.artistType;
      const requiredChainId =
        artistTypeData == 0 ? config.chainIdTx : config.chainIdSepTx;
      const rpcUrl = artistTypeData == 0 ? config.ethRpcUrl : config.baseRpcUrl;
      if (artistTypeData == 0) {
        try {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: Web3.utils.toHex(config.chainIdTx) }],
          });
        } catch (switchError) {
          if (switchError.code === 4902) {
            try {
              await window.ethereum.request({
                method: "wallet_addEthereumChain",
                params: [
                  {
                    chainId: Web3.utils.toHex(config.chainIdTx),
                    chainName: "ETH",
                    rpcUrls: [`${rpcUrl}`],
                    nativeCurrency: {
                      name: "ETH",
                      symbol: "ETH",
                      decimals: 18,
                    },
                    blockExplorerUrls: ["https://etherscan.io/"],
                  },
                ],
              });
            } catch (addError) {}
          }
        }
      } else if (artistTypeData == 1) {
        if (currentNetwork != config.chainIdSepTx) {
          try {
            await window.ethereum.request({
              method: "wallet_switchEthereumChain",
              params: [
                {
                  chainId: Web3.utils.toHex(config.chainIdSepTx),
                },
              ],
            });
          } catch (switchError) {
            if (switchError.code === 4902) {
              try {
                await window.ethereum.request({
                  method: "wallet_addEthereumChain",
                  params: [
                    {
                      chainId: Web3.utils.toHex(config.chainIdSepTx),
                      chainName: "Base",
                      rpcUrls: [`${rpcUrl}`],
                      nativeCurrency: {
                        name: "ETH",
                        symbol: "ETH",
                        decimals: 18,
                      },
                      blockExplorerUrls: ["https://basescan.org/"],
                    },
                  ],
                });
              } catch (addError) {}
            }
          }
        }
      }
      let userAddress = this.loginData.data.walletAddress;

      this.setState({
        setOpen: true,
        itemData: item,
        nfttype: type,
      });
      if (this.state.agreed == true) {
        await this.redeem(
          rpcUrl,
          item.owner_address,
          item.price,
          item.signature,
          item.contract,
          item.id,
          item.name,
          item.royalty,
          item.sellerWallet,
          item.commission,
          item.bid_increasing_amount,
          item.adminWallet,
          item.secondaryOwner,
          this.state.nfttype,
          item.ImageFileHash,
          artistTypeData
        );
      } else {
        return;
      }
    } catch (error) {
      if (error.message.toString().split("insufficient funds")[1]) {
        this.setState({
          isPopupError: true,
          msg: "Transaction reverted : " + error.message,
        });
        setTimeout(() => {
          this.setState({
            isPopupError: false,
          });
        }, 8000);
      } else {
        if (error.toString().split("execution reverted:")[1]) {
          this.setState({
            isPopupError: true,
            msg:
              "Transaction reverted : " +
              error
                .toString()
                .split("execution reverted:")[1]
                .toString()
                .split("{")[0],
          });
          setTimeout(() => {
            this.setState({
              isPopupError: false,
            });
          }, 8000);

          this.setState({
            isDialogOpen: false,
          });
        } else {
          this.setState({
            isDialogOpen: false,
          });
          this.setState({
            isPopupError: true,
            msg: error.message,
          });
          setTimeout(() => {
            this.setState({
              isPopupError: false,
            });
          }, 8000);
        }
      }
    }
  }

  async redeem(
    rpcUrl,
    owner_address,
    itemprice,
    signature,
    contract,
    itemId,
    itemName,
    royalty,
    sellerWallet,
    commission,
    bid_increasing_amount,
    adminWallet,
    secondaryOwner,
    nfttype,
    ImageFileHash,
    artistTypeData
  ) {
    try {
      const web3 = new Web3(window.ethereum);

      const accounts = await web3.eth.getAccounts();

      let userAddress = accounts[0];
      let balance = await web3.eth.getBalance(userAddress);

      this.setState({
        isDialogOpen: true,
      });

      let artistContractObject = new web3.eth.Contract(
        config.artistAbi,
        contract
      );
      let price = (itemprice * 10 ** 18).toLocaleString("fullwide", {
        useGrouping: false,
      });

      price = parseInt(price);

      let getDiscountPrice = await artistContractObject.methods
        .getDiscountPrice(userAddress, price.toString())
        .call();
      getDiscountPrice = parseInt(getDiscountPrice);

      if (balance < getDiscountPrice) {
        this.setState({
          isDialogOpen: false,
        });
        this.setState({
          isPopupError: true,
          msg: "Insufficient Balance",
        });
        setTimeout(() => {
          this.setState({
            isPopupError: false,
          });
        }, 8000);
        return;
      }
      let exprice = parseInt(getDiscountPrice).toString(); //price.toString();
      let royaltyAmount = parseInt(royalty * 10 ** 2).toString();
      let bidIncreasingAmount = parseInt(
        bid_increasing_amount * 10 ** 2
      ).toString();
      let commissionAmount = parseInt(commission * 10 ** 2).toString();

      let physicalContractObject = new web3.eth.Contract(
        config.abiplacePhysicalMarketplace,
        config.marketplacePhysicalContract
      );

      let directMint;
      console.log(
        "directMInt",
        exprice,
        royaltyAmount,
        bidIncreasingAmount == "NaN" ? "0" : bidIncreasingAmount,
        commissionAmount,
        sellerWallet === "undefined" || sellerWallet === ""
          ? adminWallet
          : sellerWallet, //commission
        secondaryOwner, //secoundary,
        ImageFileHash,
        1,
        itemId,
        userAddress
      );
      if (nfttype == 1) {
        directMint = await artistContractObject.methods.directMint(
          exprice,
          royaltyAmount,
          bidIncreasingAmount == "NaN" ? "0" : bidIncreasingAmount,
          commissionAmount,
          sellerWallet === "undefined" || sellerWallet === ""
            ? adminWallet
            : sellerWallet, //commission
          secondaryOwner, //secoundary,
          ImageFileHash,
          1,
          itemId,
          userAddress
          //secoundary
        );
      } else if (nfttype == 2) {
        directMint = await physicalContractObject.methods.purchasePhysicalNft(
          contract,
          itemId,
          exprice,
          royaltyAmount,
          bidIncreasingAmount,
          commissionAmount,
          sellerWallet === "undefined" || sellerWallet === ""
            ? adminWallet
            : sellerWallet, //commission
          secondaryOwner, //secoundary,
          ImageFileHash
        );
      }
      let encoded_tx = directMint.encodeABI();

      let gasPrice = await web3.eth.getGasPrice();
      let gasLimit = await web3.eth.estimateGas({
        gasPrice: web3.utils.toHex(gasPrice),
        to: nfttype == 1 ? contract : config.marketplacePhysicalContract,
        from: userAddress,
        data: encoded_tx,
        value: exprice,
      });
      let trx = await web3.eth.sendTransaction({
        gasPrice: web3.utils.toHex(gasPrice),
        gas: web3.utils.toHex(gasLimit),
        to: nfttype == 1 ? contract : config.marketplacePhysicalContract,
        from: userAddress,
        data: encoded_tx,
        value: exprice,
      });

      if (trx) {
        let balanceOfNFT = await artistContractObject.methods
          .balanceOf(userAddress)
          .call();
        let tokenId = await artistContractObject.methods
          .tokenOfOwnerByIndex(userAddress, parseInt(balanceOfNFT) - 1)
          .call();

        this.setState({
          isDialogOpen: false,
        });
        this.setState({
          isPopupSuccess: true,
          msg: "Nft will be displayed in your profile shortly",
        });
        setTimeout(() => {
          this.setState({
            isPopupSuccess: false,
          });
        }, 8000);

        setTimeout(() => {
          window.location.href = `${config.baseUrl}membership/${this.loginData.data.walletAddress}`;
        }, 3500);
        // await this.itemBuyApi(
        //   tokenId,
        //   trx.transactionHash,
        //   itemprice,
        //   itemId,
        //   itemName
        // );
      }
    } catch (err) {
      console.log("errr", err);
      if (err.message.toString().split("insufficient funds")[1]) {
        this.setState({
          isPopupError: true,
          msg: "Transaction reverted : " + err.message,
        });
        setTimeout(() => {
          this.setState({
            isPopupError: false,
          });
        }, 8000);
      } else {
        if (err.toString().split("execution reverted:")[1]) {
          this.setState({
            isPopupError: true,
            msg:
              "Transaction reverted : " +
              err
                .toString()
                .split("execution reverted:")[1]
                .toString()
                .split("{")[0],
          });
          setTimeout(() => {
            this.setState({
              isPopupError: false,
            });
          }, 8000);
        } else {
          this.setState({
            isPopupError: true,
            msg: err.message,
          });
          setTimeout(() => {
            this.setState({
              isPopupError: false,
            });
          }, 8000);
        }
      }
      this.setState({
        isDialogOpen: false,
      });
    }
  }

  render() {
    const settings = {
      dots: true,
      infinite: true,
      speed: 500,

      slidesToShow:
        this.state.getCollectionDetailByArtistIdData.length > 4
          ? 4
          : this.state.getCollectionDetailByArtistIdData.length,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
          },
        },
      ],
    };
    return (
      <>
        <div className="body_bg">
          <Helmet>
            <title>{this.state.seoList?.title}</title>
            <meta title={this.state.seoList?.pageTitle} content="IE=edge" />
            <meta
              name="description"
              content={this.state.seoList?.description
                ?.replace(/<[^>]*>?/gm, "")
                .substring(0, 170)}
            />
          </Helmet>
          <Header1 />
          <Popup
            isPopupError={this.state.isPopupError}
            isPopupSuccess={this.state.isPopupSuccess}
            msg={this.state.msg}
          />
          <Dialog
            title="Warning"
            icon="warning-sign"
            className="transaction-process"
            style={{
              color: "red",
              zIndex: "1111",
            }}
            isOpen={this.state.isDialogOpen}
            isCloseButtonShown={false}
          >
            <div className="text-center">
              <BarLoader color="#e84747" height="2" />
              <br />
              <h4 style={{ color: "#000" }}>Transaction under process...</h4>
              <p style={{ color: "red" }}>
                Please do not refresh page or close tab.
              </p>
              <div></div>
            </div>
          </Dialog>

          {/*---------------------- Item Activity Section Start -------------------- */}

          <section className="itemactivity pt-lg-5 pt-3">
            <div className="container-fluid px-lg-5">
              <div className="row">
                <div className="col-lg-12 col-md-12 col-12 mb-4">
                  <Fade left>
                    <div className="card afgenesiscard">
                      <div className="row g-0">
                        <div className="col-lg-6 col-md-6 col-12">
                          <div className="itemcard mb-lg-0 mb-md-5">
                            <Swiper
                              style={{
                                "--swiper-navigation-color": "#fff",
                                "--swiper-pagination-color": "#fff",
                              }}
                              loop={true}
                              spaceBetween={10}
                              navigation={true}
                              thumbs={{ swiper: this.state.thumbsSwiper }}
                              modules={[FreeMode, Navigation, Thumbs]}
                              className="mySwiper2 mb-3"
                            >
                              {/* Pehla Slide - listSingleItemData */}
                              <SwiperSlide>
                                <div className="cardblock p-3">
                                  {this.state.listSingleItemData.file_type ===
                                  "image" ? (
                                    <a
                                      href={
                                        config.imageUrl1 +
                                        this.state.listSingleItemData.image
                                      }
                                      target="_blank"
                                    >
                                      <img
                                        src={
                                          config.imageUrl1 +
                                          this.state.listSingleItemData.image
                                        }
                                        alt="Slide"
                                        className=""
                                        style={{
                                          width: "688px",
                                          height: "523px",
                                        }}
                                      />
                                    </a>
                                  ) : this.state.listSingleItemData
                                      .file_type === "video" ? (
                                    <Player
                                      style={{ width: "100%" }}
                                      alt="itemback"
                                      src={`${config.imageUrl1}${this.state.listSingleItemData.image}`}
                                      className=""
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </SwiperSlide>

                              {/* Agar multipleDigImages me images hain to unko bhi add karo */}
                              {this.state.multipleDigImages &&
                                this.state.multipleDigImages.length > 0 &&
                                this.state.multipleDigImages.map(
                                  (item, index) => (
                                    <SwiperSlide key={index}>
                                      <div className="cardblock p-3">
                                        <a
                                          href={config.imageUrl1 + item.image}
                                          target="_blank"
                                        >
                                          <img
                                            src={config.imageUrl1 + item.image}
                                            alt={`Slide ${index + 1}`}
                                            style={{
                                              width: "688px",
                                              height: "523px",
                                            }}
                                          />
                                        </a>
                                      </div>
                                    </SwiperSlide>
                                  )
                                )}
                            </Swiper>

                            <Swiper
                              onSwiper={this.setThumbsSwiper}
                              loop={true}
                              spaceBetween={10}
                              slidesPerView={5}
                              freeMode={true}
                              watchSlidesProgress={true}
                              modules={[FreeMode, Navigation, Thumbs]}
                              className="mySwiper"
                            >
                              <SwiperSlide>
                                {this.state.listSingleItemData.file_type ===
                                "image" ? (
                                  <img
                                    src={
                                      config.imageUrl1 +
                                      this.state.listSingleItemData.image
                                    }
                                    alt="Slide"
                                    width="100%"
                                    height="150px"
                                    className="object-fit-contain"
                                  />
                                ) : this.state.listSingleItemData.file_type ===
                                  "video" ? (
                                  <Player
                                    alt="Slide"
                                    width="100%"
                                    height="150px"
                                    className="object-fit-contain"
                                    src={`${config.imageUrl1}${this.state.listSingleItemData.image}`}
                                  />
                                ) : (
                                  ""
                                )}
                              </SwiperSlide>

                              {this.state.multipleDigImages &&
                                this.state.multipleDigImages.length > 0 &&
                                this.state.multipleDigImages.map(
                                  (item, index) => (
                                    <SwiperSlide key={index}>
                                      <img
                                        src={config.imageUrl1 + item.image}
                                        alt={`Slide ${index + 1}`}
                                        width="100%"
                                        height="150px"
                                        className="object-fit-contain"
                                      />
                                    </SwiperSlide>
                                  )
                                )}
                            </Swiper>

                            <div className="viewbox">
                              <div></div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-12">
                          <div className="card-body px-0 pt-0">
                            <div className="genesistext mb-3">
                              <div className="d-flex justify-content-between align-items-center">
                                <div>
                                  <p class="card-text position-relative d-inline-block px-2">
                                    {this.type === 1
                                      ? "Digital Artwork"
                                      : "Physical Artwork"}
                                  </p>
                                </div>
                                <div>
                                  <a
                                    href="javascript:void(0)"
                                    className="view p-0 "
                                  >
                                    <span
                                      className="mr-2"
                                      title={
                                        this.state.listSingleItemData
                                          .viewCount + " Views"
                                      }
                                    >
                                      <img src="images/icon/eye.png" />
                                    </span>
                                  </a>
                                </div>
                              </div>
                            </div>
                            <div className="itemdetail mb-4">
                              <div className="genesistext">
                                <h4 className="">
                                  {/* In Full Bloom */}
                                  {this.state.listSingleItemData.name}
                                </h4>

                                <div className="mb-4">
                                  <ul>
                                    {this.state.listSingleItemData
                                      .firstPurchase == 1 ? (
                                      <>
                                        <li className="my-3">
                                          <h5 className="text-grey">
                                            <span className="workIcon">By</span>
                                            &nbsp;
                                            <strong
                                              style={{ color: "#101111" }}
                                            >
                                              {" "}
                                              {
                                                this.state.listSingleItemData
                                                  .creatorName
                                              }
                                            </strong>
                                          </h5>
                                        </li>

                                        <li>
                                          <li className="my-3">
                                            <p>
                                              Owned by{" "}
                                              <a
                                                href={
                                                  this.state.listSingleItemData
                                                    .artistType == 0
                                                    ? config.blockchinUrlAddress +
                                                      (this.state
                                                        .listSingleItemData
                                                        .ownerName
                                                        ? this.state
                                                            .listSingleItemData
                                                            .ownerName
                                                        : this.state
                                                            ?.latestOwner[0]
                                                            ?.address
                                                        ? this.state
                                                            ?.latestOwner[0]
                                                            ?.address
                                                        : this.state
                                                            .listSingleItemData
                                                            .owner_address)
                                                    : config.blockchinUrlSep +
                                                      (this.state
                                                        .listSingleItemData
                                                        .ownerName
                                                        ? this.state
                                                            .listSingleItemData
                                                            .ownerName
                                                        : this.state
                                                            ?.latestOwner[0]
                                                            ?.address
                                                        ? this.state
                                                            ?.latestOwner[0]
                                                            ?.address
                                                        : this.state
                                                            .listSingleItemData
                                                            .owner_address)
                                                }
                                                target="_blank"
                                              >
                                                {" "}
                                                {this.state.listSingleItemData
                                                  .ownerName
                                                  ? this.state
                                                      .listSingleItemData
                                                      .ownerName
                                                  : this.state?.latestOwner[0]
                                                      ?.address
                                                  ? this.state?.latestOwner[0]?.address?.substring(
                                                      0,
                                                      6
                                                    ) +
                                                    "...." +
                                                    this.state?.latestOwner[0]?.address?.substring(
                                                      this.state?.latestOwner[0]
                                                        ?.address?.length - 6
                                                    )
                                                  : this.state.listSingleItemData.owner_address?.substring(
                                                      0,
                                                      6
                                                    ) +
                                                    "...." +
                                                    this.state.listSingleItemData.owner_address?.substring(
                                                      this.state
                                                        .listSingleItemData
                                                        .owner_address?.length -
                                                        6
                                                    )}
                                                &nbsp;
                                              </a>
                                              <CopyToClipboard
                                                text={
                                                  this.state.listSingleItemData
                                                    .artistType == 0
                                                    ? config.blockchinUrlAddress +
                                                      (this.state
                                                        .listSingleItemData
                                                        .ownerName
                                                        ? this.state
                                                            .listSingleItemData
                                                            .ownerName
                                                        : this.state
                                                            ?.latestOwner[0]
                                                            ?.address
                                                        ? this.state
                                                            ?.latestOwner[0]
                                                            ?.address
                                                        : this.state
                                                            .listSingleItemData
                                                            .owner_address)
                                                    : config.blockchinUrlSep +
                                                      (this.state
                                                        .listSingleItemData
                                                        .ownerName
                                                        ? this.state
                                                            .listSingleItemData
                                                            .ownerName
                                                        : this.state
                                                            ?.latestOwner[0]
                                                            ?.address
                                                        ? this.state
                                                            ?.latestOwner[0]
                                                            ?.address
                                                        : this.state
                                                            .listSingleItemData
                                                            .owner_address)
                                                }
                                              >
                                                <span
                                                  title="Click to Copy"
                                                  className="mr-copylink"
                                                  id="token-buy-button"
                                                  onClick={this.copieBtn}
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "rgb(157 81 255)",
                                                  }}
                                                >
                                                  <i className="fa fa-copy "></i>
                                                </span>
                                              </CopyToClipboard>
                                            </p>
                                          </li>
                                        </li>
                                      </>
                                    ) : (
                                      ""
                                    )}

                                    {this.type == 1 ? (
                                      ""
                                    ) : (
                                      <>
                                        <li className="my-3">
                                          <h5 className="text-grey">
                                            <span className="shippingIcon">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="25"
                                                viewBox="0 0 24 25"
                                                fill="none"
                                              >
                                                <g clip-path="url(#clip0_118_8219)">
                                                  <path
                                                    d="M23.776 13.3989L21.8548 9.17234C21.6955 8.82311 21.4393 8.52698 21.1166 8.31915C20.7939 8.11132 20.4183 8.00055 20.0345 8H16.5001V6.5C16.4997 6.10231 16.3415 5.72103 16.0603 5.43982C15.7791 5.15861 15.3978 5.00043 15.0001 5H2.50007C2.10238 5.00043 1.7211 5.15861 1.43989 5.43982C1.15868 5.72103 1.00051 6.10231 1.00007 6.5V12.5C0.999433 12.5661 1.01189 12.6316 1.03673 12.6928C1.06157 12.7541 1.0983 12.8097 1.14479 12.8567C1.19129 12.9036 1.24662 12.9409 1.3076 12.9663C1.36858 12.9918 1.43399 13.0049 1.50007 13.0049C1.56614 13.0049 1.63155 12.9918 1.69253 12.9663C1.75351 12.9409 1.80884 12.9036 1.85534 12.8567C1.90183 12.8097 1.93856 12.7541 1.9634 12.6928C1.98824 12.6316 2.0007 12.5661 2.00006 12.5V6.5C2.00021 6.36743 2.05293 6.24034 2.14667 6.1466C2.24041 6.05286 2.36751 6.00013 2.50007 5.99998H15.0001C15.1327 6.00013 15.2597 6.05286 15.3535 6.1466C15.4472 6.24034 15.5 6.36743 15.5001 6.5V14.5C15.4999 14.6326 15.4472 14.7596 15.3534 14.8534C15.2597 14.9471 15.1326 14.9998 15.0001 15H9.00009C8.86832 15.0013 8.74238 15.0545 8.64966 15.1481C8.55693 15.2418 8.50491 15.3682 8.50491 15.5C8.50491 15.6318 8.55693 15.7582 8.64966 15.8518C8.74238 15.9455 8.86832 15.9987 9.00009 16H15.0001C15.3978 15.9995 15.7791 15.8414 16.0603 15.5601C16.3415 15.2789 16.4997 14.8977 16.5001 14.5V8.99998H20.0345C20.2264 9.00025 20.4142 9.05563 20.5756 9.15954C20.737 9.26346 20.8652 9.41153 20.9449 9.58616L21.133 9.99997H19.0002C18.735 10.0002 18.4808 10.1057 18.2933 10.2932C18.1058 10.4806 18.0004 10.7349 18.0001 11V13C18.0003 13.2651 18.1058 13.5193 18.2933 13.7068C18.4807 13.8943 18.7349 13.9997 19.0001 14H22.9282C22.9736 14.14 22.9979 14.286 23.0003 14.4331V16.5C23.0001 16.6326 22.9473 16.7597 22.8536 16.8534C22.7598 16.9472 22.6327 16.9999 22.5001 17H20.9496C20.8343 16.4354 20.5275 15.928 20.0812 15.5636C19.6348 15.1992 19.0763 15.0001 18.5001 15.0001C17.9239 15.0001 17.3654 15.1992 16.919 15.5636C16.4727 15.928 16.1659 16.4354 16.0506 17H7.94957C7.83431 16.4354 7.52755 15.928 7.08121 15.5636C6.63486 15.1992 6.07634 15.0001 5.50012 15.0001C4.9239 15.0001 4.36538 15.1992 3.91903 15.5636C3.47269 15.928 3.16593 16.4354 3.05067 17H2.50007C2.36751 16.9998 2.24043 16.9471 2.1467 16.8534C2.05297 16.7596 2.00023 16.6325 2.00006 16.5V16C2.13182 15.9987 2.25776 15.9455 2.35049 15.8519C2.44321 15.7582 2.49523 15.6318 2.49523 15.5C2.49523 15.3682 2.44321 15.2418 2.35049 15.1482C2.25776 15.0545 2.13182 15.0013 2.00006 15H0.500057C0.36829 15.0013 0.242352 15.0545 0.149626 15.1482C0.0569005 15.2418 0.00488281 15.3682 0.00488281 15.5C0.00488281 15.6318 0.0569005 15.7582 0.149626 15.8519C0.242352 15.9455 0.36829 15.9987 0.500057 16H1.00007V16.5C1.00051 16.8977 1.15868 17.279 1.43989 17.5602C1.7211 17.8414 2.10238 17.9996 2.50007 18H3.05062C3.16589 18.5646 3.47264 19.072 3.91898 19.4364C4.36533 19.8009 4.92386 19.9999 5.50007 19.9999C6.07629 19.9999 6.63482 19.8009 7.08116 19.4364C7.5275 19.072 7.83426 18.5646 7.94953 18H16.0506C16.1659 18.5646 16.4726 19.072 16.919 19.4364C17.3653 19.8009 17.9238 19.9999 18.5001 19.9999C19.0763 19.9999 19.6348 19.8009 20.0811 19.4364C20.5275 19.072 20.8342 18.5646 20.9495 18H22.5001C22.8978 17.9996 23.2791 17.8414 23.5603 17.5602C23.8415 17.279 23.9997 16.8977 24.0001 16.5V14.4331C24.0007 14.0763 23.9242 13.7235 23.776 13.3989ZM5.50007 19C5.2034 19 4.91339 18.912 4.66672 18.7472C4.42004 18.5824 4.22778 18.3481 4.11425 18.074C4.00072 17.8 3.97102 17.4984 4.02889 17.2074C4.08677 16.9164 4.22963 16.6491 4.43941 16.4394C4.64919 16.2296 4.91647 16.0867 5.20744 16.0288C5.49841 15.971 5.80001 16.0007 6.0741 16.1142C6.34819 16.2277 6.58246 16.42 6.74728 16.6667C6.9121 16.9133 7.00007 17.2033 7.00007 17.5C6.99964 17.8977 6.84146 18.279 6.56025 18.5602C6.27904 18.8414 5.89776 18.9996 5.50007 19ZM18.5001 19C18.2034 19 17.9134 18.912 17.6667 18.7472C17.42 18.5824 17.2278 18.3481 17.1142 18.074C17.0007 17.8 16.971 17.4984 17.0289 17.2074C17.0868 16.9164 17.2296 16.6491 17.4394 16.4394C17.6492 16.2296 17.9164 16.0867 18.2074 16.0288C18.4984 15.971 18.8 16.0007 19.0741 16.1142C19.3482 16.2277 19.5824 16.42 19.7473 16.6667C19.9121 16.9133 20.0001 17.2033 20.0001 17.5C19.9996 17.8977 19.8415 18.279 19.5603 18.5602C19.2791 18.8414 18.8978 18.9996 18.5001 19H18.5001ZM19.0001 11H21.5873L22.4964 13H19.0001V11Z"
                                                    fill="#767676"
                                                  />
                                                  <path
                                                    d="M0.500057 14.5H3.00004C3.13181 14.4987 3.25775 14.4455 3.35047 14.3519C3.4432 14.2582 3.49522 14.1318 3.49522 14C3.49522 13.8682 3.4432 13.7418 3.35047 13.6482C3.25775 13.5545 3.13181 13.5013 3.00004 13.5H0.500057C0.36829 13.5013 0.242352 13.5545 0.149626 13.6482C0.0569005 13.7418 0.00488281 13.8682 0.00488281 14C0.00488281 14.1318 0.0569005 14.2582 0.149626 14.3519C0.242352 14.4455 0.36829 14.4987 0.500057 14.5Z"
                                                    fill="#767676"
                                                  />
                                                </g>
                                                <defs>
                                                  <clipPath id="clip0_118_8219">
                                                    <rect
                                                      width="24"
                                                      height="24"
                                                      fill="white"
                                                      transform="translate(0 0.5)"
                                                    />
                                                  </clipPath>
                                                </defs>
                                              </svg>
                                            </span>
                                            &nbsp;&nbsp; Shipping available in{" "}
                                            {!this.state.listSingleItemData
                                              .country ||
                                            !this.state.listSingleItemData.area
                                              ? "Worldwide"
                                              : `${this.state.listSingleItemData.area}, ${this.state.listSingleItemData.country} only`}
                                          </h5>
                                        </li>
                                      </>
                                    )}
                                  </ul>
                                </div>

                                {this.state.listSingleItemData.firstPurchase ==
                                1 ? (
                                  <h4 className="my-3">
                                    {this.state.listSingleItemData.sell_type ===
                                    2
                                      ? "Initial Bid Price: "
                                      : "Price: "}
                                    {this.state.listSingleItemData.price}{" "}
                                    {this.state.listSingleItemData.artistType ==
                                    0
                                      ? config.currencyType
                                      : config.currencyTypeSep}
                                  </h4>
                                ) : (
                                  <h4 className="my-3">
                                    {this.state.listSingleItemData.price}{" "}
                                    {this.state.listSingleItemData.artistType ==
                                    0
                                      ? config.currencyType
                                      : config.currencyTypeSep}
                                  </h4>
                                )}
                              </div>

                              {this.state.listSingleItemData.firstPurchase ==
                              1 ? (
                                <>
                                  <div className="d-lg-flex align-items-end">
                                    {this.state.listSingleItemData.is_sold ===
                                    1 ? (
                                      <label
                                        style={{
                                          color: "red",
                                          fontSize: "26px",
                                        }}
                                      >
                                        Sold Out
                                      </label>
                                    ) : (
                                      <>
                                        <div className="pt-4 listing_box">
                                          {this.state.listSingleItemData
                                            .ownerName ? (
                                            this.state.listSingleItemData
                                              .ownerName
                                          ) : (this.state?.latestOwner[0]
                                              ?.address.toLowerCase() ==
                                              this.loginData.data
                                                ?.walletAddress.toLowerCase()) ? (
                                            this.state.listSingleItemData
                                              .sell_type === 1 ? (
                                              <>
                                                <span className="mr-3 ownernft">
                                                  You are owner of this NFT2
                                                </span>
                                                <br></br>

                                                <button
                                                  type="button"
                                                  className="custombtn genesis2 text-center"
                                                  onClick={this.cancelListing.bind(
                                                    this
                                                  )}
                                                >
                                                  Cancel Listing
                                                </button>
                                              </>
                                            ) : this.state.listSingleItemData
                                                .anyBid === 0 ? (
                                              <>
                                                <div className="mr-3 ownernft mb-2">
                                                  You are owner of this NFT3
                                                </div>

                                                <button
                                                  onClick={this.cancelListing.bind(
                                                    this
                                                  )}
                                                  type="submit"
                                                  className="custombtn genesis2 text-center"
                                                >
                                                  Cancel Listing
                                                </button>
                                              </>
                                            ) : (
                                              <span className="mr-3 ownernft">
                                                You are owner of this NFT
                                              </span>
                                            )
                                          ) : this.state.listSingleItemData
                                              .sell_type === 1 ? (
                                            <button
                                              type="button"
                                              className="custombtn genesis2 text-center mb-3"
                                              onClick={(e) => {
                                                this.buyNft(e);
                                              }}
                                            > 
                                            
                                              Buy
                                              
                                            </button>
                                          ) : (
                                            <button
                                              {...(this.state.listSingleItemData.owner_address.toLowerCase() !==
                                              this.loginData.data.walletAddress.toLowerCase()
                                                ? {
                                                    "data-toggle": "modal",
                                                    "data-target":
                                                      "#exampleModal",
                                                  }
                                                : {})}
                                              disabled={
                                                this.state.expData1 <
                                                  this.state.newDateData ||
                                                this.state.listSingleItemData.owner_address.toLowerCase() ===
                                                  this.loginData.data.walletAddress.toLowerCase()
                                              }
                                              type="button"
                                              className="custombtn genesis2 text-center mb-3"
                                            >
                                              {this.state.listSingleItemData.owner_address.toLowerCase() ===
                                              this.loginData.data.walletAddress.toLowerCase()
                                                ? "You are owner of this NFT1"
                                                : "Place Bid"}
                                            </button>
                                          )}
                                        </div>
                                      </>
                                    )}
                                    &nbsp;&nbsp;
                                    {this.state.listSingleItemData
                                      .isWishList === 0 ? (
                                      <button
                                        onClick={this.WishListAction.bind(this)}
                                        type="button"
                                        className="custombtn genesis2 text-center "
                                      >
                                        Add To wishlist
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        className="custombtn genesis2 text-center "
                                        disabled
                                      >
                                        Already In wishlist
                                      </button>
                                    )}
                                  </div>
                                  <div className="metadata mt-3">
                                    <a
                                      target="_blank"
                                      href={
                                        (this.state.listSingleItemData
                                          .artistType == 0
                                          ? config.blockchinUrlAddress
                                          : config.blockchinUrlSep) +
                                        this.state.listSingleItemData.contract
                                        // (this.state.listSingleItemData
                                        //   .artistType == 0
                                        //   ? config.marketplaceContract
                                        //   : config.marketplaceContractBase)
                                      }
                                    >
                                      <h6 className="">Blockchain view</h6>
                                    </a>

                                    <a
                                      target="_blank"
                                      href={
                                        config.ipfsUrl +
                                        this.state.listSingleItemData.ipfs_hash
                                      }
                                    >
                                      <h6 className="ml-4">IPFS view</h6>
                                    </a>

                                    <h6 className="ml-4">
                                      Token ID:{" "}
                                      {this.state.listSingleItemData.token_id}
                                    </h6>
                                  </div>
                                </>
                              ) : (
                                <div className="">
                                  <button
                                    type="button"
                                    className="custombtn genesis2 text-center mb-3"
                                    onClick={(e) =>
                                      this.mint(
                                        e,
                                        this.state.listSingleItemData,
                                        this.type === 1 ? 1 : 2
                                      )
                                    }
                                  >
                                    Buy{" "}
                                  </button>
                                </div>
                              )}
                            </div>
                            <div>
                              <div className="card mb-4">
                                <div className="card-body">
                                  <h5 className="fw-bold">Item Details</h5>
                                  <p className="text-grey mb-0">
                                    {this.state.listSingleItemData.description
                                      ?.length > MAX_LENGTH ? (
                                      <p
                                        className="mb-2 configrat"
                                        title={
                                          this.state.listSingleItemData
                                            .description
                                        }
                                      >
                                        {`${this.state.listSingleItemData.description.substring(
                                          0,
                                          MAX_LENGTH
                                        )}...`}
                                      </p>
                                    ) : (
                                      <p
                                        className="mb-2 configrat"
                                        title={
                                          this.state.listSingleItemData
                                            .description
                                        }
                                      >
                                        {
                                          this.state.listSingleItemData
                                            .description
                                        }
                                      </p>
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>

                            <div>
                              <div className="card mb-4">
                                <div className="card-body">
                                  <h5 className="fw-bold">
                                    Additional Information
                                  </h5>
                                  <p className="text-grey mb-0">
                                    {this.state.listSingleItemData
                                      .longDescription?.length > MAX_LENGTH ? (
                                      <p
                                        className="mb-2 configrat"
                                        title={
                                          this.state.listSingleItemData
                                            .longDescription
                                        }
                                      >
                                        {`${this.state.listSingleItemData.longDescription.substring(
                                          0,
                                          MAX_LENGTH
                                        )}...`}
                                      </p>
                                    ) : (
                                      <p
                                        className="mb-2 configrat"
                                        title={
                                          this.state.listSingleItemData
                                            .longDescription
                                        }
                                      >
                                        {
                                          this.state.listSingleItemData
                                            .longDescription
                                        }
                                      </p>
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                            {this.type == 1 ? (
                              ""
                            ) : (
                              <div>
                                {this.state.listSingleItemData
                                  .shippingPolicy ? (
                                  <div className="card">
                                    <div className="card-body">
                                      <h5 className="fw-bold">
                                        Shipping And Return Policy
                                      </h5>
                                      <p className="text-grey mb-0">
                                        {
                                          this.state.listSingleItemData
                                            .shippingPolicy
                                        }
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                <br />
                                {this.state.listSingleItemData.remarks ? (
                                  <div className="card">
                                    <div className="card-body">
                                      <h5 className="fw-bold">
                                        More Information
                                      </h5>
                                      <p className="text-grey mb-0">
                                        {this.state.listSingleItemData.remarks}
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          {/*---------------------- Item Activity Section End -------------------- */}

          {/*---------------------- Item Table Section Start -------------------- */}
          {this.state.listSingleItemData.firstPurchase == 1 ? (
            <section className="itematable py-lg-5 pt-3">
              <div className="container-fluid px-lg-5">
                <div className="row">
                  <div className="col-12 text-center mb-4">
                    <h2 className="tophead">Item Activity</h2>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-8 col-md-12 col-12 mx-auto">
                    <Bounce top>
                      <div className="table-responsive itemscontent">
                        <table className="table table-hover mb-lg-0">
                          <thead>
                            <tr>
                              <th>Event</th>
                              <th>Price</th>
                              <th>From</th>
                              <th>To</th>
                              <th>Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state?.itemActivityData?.length == 0 ? (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No Activity found
                                </td>
                              </tr>
                            ) : (
                              this.state?.itemActivityData?.map((item) => (
                                <Fragment key={item.id}>
                                  <tr>
                                    <td>{item.nft_activity_type}</td>
                                    <td>
                                      {item.amount}{" "}
                                      {this.state.listSingleItemData
                                        .artistType == 0
                                        ? config.currencyType
                                        : config.currencyTypeSep}
                                    </td>
                                    <td>
                                      {" "}
                                      {item?.from_user == "null" ? (
                                        this.state.listSingleItemData
                                          .creatorName
                                      ) : item.nft_activity_type_id == 3 ? (
                                        this.state.listSingleItemData
                                          .creatorName
                                      ) : item.nft_activity_type_id == 2 ? (
                                        <>
                                          <div>
                                            {item?.address?.substring(0, 4) +
                                              "...." +
                                              item?.address?.substring(
                                                item?.address?.length - 4
                                              )}
                                            <CopyToClipboard
                                              text={item.address}
                                            >
                                              <span
                                                title="Click to Copy"
                                                className="mr-copylink"
                                                id="token-buy-button"
                                                onClick={this.copieBtn}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "rgb(157 81 255)",
                                                }}
                                              >
                                                &nbsp;
                                                <i className="fa fa-copy "></i>
                                              </span>
                                            </CopyToClipboard>
                                          </div>
                                        </>
                                      ) : item.nft_activity_type_id == 5 ? (
                                        <>
                                          <div>
                                            {item?.address?.substring(0, 4) +
                                              "...." +
                                              item?.address?.substring(
                                                item?.address?.length - 4
                                              )}
                                            <CopyToClipboard
                                              text={item.address}
                                            >
                                              <span
                                                title="Click to Copy"
                                                className="mr-copylink"
                                                id="token-buy-button"
                                                onClick={this.copieBtn}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "rgb(157 81 255)",
                                                }}
                                              >
                                                &nbsp;
                                                <i className="fa fa-copy "></i>
                                              </span>
                                            </CopyToClipboard>
                                          </div>
                                        </>
                                      ) : item.nft_activity_type_id === 4 ? (
                                        item.from_name ? (
                                          item.from_name
                                        ) : (
                                          <>
                                            <div>
                                              {item?.sellerAddress?.substring(
                                                0,
                                                4
                                              ) +
                                                "...." +
                                                item?.sellerAddress?.substring(
                                                  item?.sellerAddress?.length -
                                                    4
                                                )}
                                              <CopyToClipboard
                                                text={item.sellerAddress}
                                              >
                                                <span
                                                  title="Click to Copy"
                                                  className="mr-copylink"
                                                  id="token-buy-button"
                                                  onClick={this.copieBtn}
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "rgb(157 81 255)",
                                                  }}
                                                >
                                                  &nbsp;
                                                  <i className="fa fa-copy "></i>
                                                </span>
                                              </CopyToClipboard>
                                            </div>
                                          </>
                                        )
                                      ) : item.nft_activity_type_id == 6 ? (
                                        <>
                                          <div>
                                            {item?.oactualOwner?.substring(
                                              0,
                                              4
                                            ) +
                                              "...." +
                                              item?.oactualOwner?.substring(
                                                item?.oactualOwner?.length - 4
                                              )}
                                            <CopyToClipboard
                                              text={item.oactualOwner}
                                            >
                                              <span
                                                title="Click to Copy"
                                                className="mr-copylink"
                                                id="token-buy-button"
                                                onClick={this.copieBtn}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "rgb(157 81 255)",
                                                }}
                                              >
                                                &nbsp;
                                                <i className="fa fa-copy "></i>
                                              </span>
                                            </CopyToClipboard>
                                          </div>
                                        </>
                                      ) : item.nft_activity_type_id == 7 &&
                                        this.type == 1 ? (
                                        <>
                                          <div>
                                            {item?.address?.substring(0, 4) +
                                              "...." +
                                              item?.address?.substring(
                                                item?.address?.length - 4
                                              )}
                                            <CopyToClipboard
                                              text={item.address}
                                            >
                                              <span
                                                title="Click to Copy"
                                                className="mr-copylink"
                                                id="token-buy-button"
                                                onClick={this.copieBtn}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "rgb(157 81 255)",
                                                }}
                                              >
                                                &nbsp;
                                                <i className="fa fa-copy "></i>
                                              </span>
                                            </CopyToClipboard>
                                          </div>
                                        </>
                                      ) : item.nft_activity_type_id == 7 &&
                                        this.type == 2 ? (
                                        <>
                                          <div>
                                            {item?.sellerAddress?.substring(
                                              0,
                                              4
                                            ) +
                                              "...." +
                                              item?.sellerAddress?.substring(
                                                item?.sellerAddress?.length - 4
                                              )}
                                            <CopyToClipboard
                                              text={item.sellerAddress}
                                            >
                                              <span
                                                title="Click to Copy"
                                                className="mr-copylink"
                                                id="token-buy-button"
                                                onClick={this.copieBtn}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "rgb(157 81 255)",
                                                }}
                                              >
                                                &nbsp;
                                                <i className="fa fa-copy "></i>
                                              </span>
                                            </CopyToClipboard>
                                          </div>
                                        </>
                                      ) : item.nft_activity_type_id == 8 ? (
                                        <>
                                          <div>
                                            {item?.from_user > 0
                                              ? item?.from_user?.substring(
                                                  0,
                                                  4
                                                ) +
                                                "...." +
                                                item?.from_user?.substring(
                                                  item?.from_user?.length - 4
                                                )
                                              : ""}
                                            {item?.from_user > 0 ? (
                                              <CopyToClipboard
                                                text={item?.from_user}
                                              >
                                                <span
                                                  title="Click to Copy"
                                                  className="mr-copylink"
                                                  id="token-buy-button"
                                                  onClick={this.copieBtn}
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "rgb(157 81 255)",
                                                  }}
                                                >
                                                  &nbsp;
                                                  <i className="fa fa-copy "></i>
                                                </span>
                                              </CopyToClipboard>
                                            ) : (
                                              ""
                                            )}
                                          </div>
                                        </>
                                      ) : (
                                        item.to_name
                                      )}
                                    </td>
                                    <td>
                                      {item.to_user === 0 &&
                                      item?.from_user === null ? (
                                        "-"
                                      ) : item.nft_activity_type_id === 3 ? (
                                        <>
                                          <div>
                                            {item?.address?.substring(0, 4) +
                                              "...." +
                                              item?.address?.substring(
                                                item?.address?.length - 4
                                              )}
                                            <CopyToClipboard
                                              text={item.address}
                                            >
                                              <span
                                                title="Click to Copy"
                                                className="mr-copylink"
                                                id="token-buy-button"
                                                onClick={this.copieBtn}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "rgb(157 81 255)",
                                                }}
                                              >
                                                &nbsp;
                                                <i className="fa fa-copy "></i>
                                              </span>
                                            </CopyToClipboard>
                                          </div>
                                        </>
                                      ) : item.nft_activity_type_id === 2 ? (
                                        <>-</>
                                      ) : item.nft_activity_type_id == 4 ? (
                                        item.to_name ? (
                                          item.to_name
                                        ) : (
                                          <>
                                            <div>
                                              {item?.address?.substring(0, 4) +
                                                "...." +
                                                item?.address?.substring(
                                                  item?.address?.length - 4
                                                )}
                                              <CopyToClipboard
                                                text={item.address}
                                              >
                                                <span
                                                  title="Click to Copy"
                                                  className="mr-copylink"
                                                  id="token-buy-button"
                                                  onClick={this.copieBtn}
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "rgb(157 81 255)",
                                                  }}
                                                >
                                                  &nbsp;
                                                  <i className="fa fa-copy "></i>
                                                </span>
                                              </CopyToClipboard>
                                            </div>
                                          </>
                                        )
                                      ) : item.nft_activity_type_id == 6 ? (
                                        item.to_name ? (
                                          item.to_name
                                        ) : (
                                          <>
                                            <div>
                                              {item?.address?.substring(0, 4) +
                                                "...." +
                                                item?.address?.substring(
                                                  item?.address?.length - 4
                                                )}
                                              <CopyToClipboard
                                                text={item.address}
                                              >
                                                <span
                                                  title="Click to Copy"
                                                  className="mr-copylink"
                                                  id="token-buy-button"
                                                  onClick={this.copieBtn}
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "rgb(157 81 255)",
                                                  }}
                                                >
                                                  &nbsp;
                                                  <i className="fa fa-copy "></i>
                                                </span>
                                              </CopyToClipboard>
                                            </div>
                                          </>
                                        )
                                      ) : item.nft_activity_type_id == 8 ? (
                                        <div>
                                          {item?.address?.substring(0, 4) +
                                            "...." +
                                            item?.address?.substring(
                                              item?.address?.length - 4
                                            )}
                                          <CopyToClipboard text={item.address}>
                                            <span
                                              title="Click to Copy"
                                              className="mr-copylink"
                                              id="token-buy-button"
                                              onClick={this.copieBtn}
                                              style={{
                                                cursor: "pointer",
                                                color: "rgb(157 81 255)",
                                              }}
                                            >
                                              &nbsp;
                                              <i className="fa fa-copy "></i>
                                            </span>
                                          </CopyToClipboard>
                                        </div>
                                      ) : (
                                        item.from_name
                                      )}
                                    </td>
                                    <td>
                                      {" "}
                                      {moment(item.datetime).format(
                                        "YYYY-MM-DD"
                                      )}
                                    </td>
                                  </tr>
                                </Fragment>
                              ))
                            )}
                          </tbody>
                        </table>
                      </div>
                    </Bounce>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            ""
          )}

          {/*---------------------- Item Table Section End -------------------- */}

          {/*---------------------- Seasky Collection Section Start -------------------- */}

          <section className="seasky_collection py-5">
            <div className="container-fluid px-lg-5">
              <div className="row">
                <div className="col-12 mb-4">
                  <h2 className="tophead">More from this collection</h2>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12">
                  {this.state.getCollectionDetailByArtistIdData.length === 0 ? (
                    <h2 className="text-center">No Collection Found</h2>
                  ) : (
                    ""
                  )}
                </div>
                <div className="col-lg-12">
                  <div className="row">
                    {" "}
                    {/* Added row for Bootstrap grid system */}
                    {this.state.getCollectionDetailByArtistIdData.map(
                      (item) => {
                        return (
                          <div
                            className="col-xl-4 col-lg-6 col-md-6 col-12 text-center mb-4"
                            key={item.collectionId}
                          >
                            {" "}
                            {/* Key moved here */}
                            <div className="">
                              <div className="card feature">
                                <div className="cardblock">
                                  <a
                                    href="javascript:void(0)"
                                    onClick={this.collectionLinkFeat.bind(
                                      this,
                                      item,
                                      this.type == 1 ? 1 : 2
                                    )}
                                  >
                                    {item?.file_type === "image" ? (
                                      <img
                                        className="card-img-top img-fluid"
                                        src={config.imageUrl1 + item.image}
                                        alt="Physical Artwork"
                                        style={{
                                          height: "250px",
                                          width: "100%",
                                        }}
                                      />
                                    ) : item.file_type === "video" ? (
                                      <Player
                                        className="marketplace-image"
                                        style={{
                                          height: "250px",
                                          width: "100%",
                                        }}
                                        src={`${config.imageUrl1}${item?.image}`}
                                      />
                                    ) : null}
                                  </a>
                                </div>
                                <div className="card-body pb-0">
                                  <h4
                                    className="card-title"
                                    style={{
                                      fontFamily: "Catamaran",
                                      fontWeight: "700",
                                    }}
                                  >
                                    <span title={item?.name}>{item?.name}</span>
                                  </h4>

                                  <p className="text-grey mb-0">
                                    {item.description
                                      ?.length > MAX_LENGTH_DESC ? (
                                      <p
                                        className="mb-2 configrat"
                                        title={
                                          item.description
                                            
                                        }
                                      >
                                        {`${item.description.substring(
                                          0,
                                          MAX_LENGTH_DESC
                                        )}...`}
                                      </p>
                                    ) : (
                                      <p
                                        className="mb-2 configrat"
                                        title={
                                          item.description
                                            
                                        }
                                      >
                                        {
                                          item.description
                                            
                                        }
                                      </p>
                                    )}
                                  </p>
                                  <h4 className="card-title">
                                    <div>
                                      <h2 className="mb-0">
                                        {item?.sell_type === 1
                                          ? item.price
                                          : item.lastBid === 0
                                          ? item.price
                                          : (
                                              item.lastBid +
                                              (item.lastBid *
                                                item.bid_increasing_amount) /
                                                100
                                            ).toFixed(4)}{" "}
                                        <span className="h5 fw-400">
                                          {item.artistType === 0
                                            ? config.currencyType
                                            : config.currencyTypeSep}
                                        </span>
                                      </h2>
                                    </div>
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/*---------------------- Seasky Collection Section End -------------------- */}
          <div
            className="modal fade"
            id="exampleModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
            data-backdrop="static"
            data-keyboard="false"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content" style={{ background: "#fff" }}>
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    Place Bid123
                  </h5>
                  <button
                    type="button"
                    className="close"
                    style={{ color: "#000" }}
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <form>
                    <div className="form-group">
                      <label
                        htmlFor="recipient-name"
                        className="col-form-label"
                      >
                        Please Enter New{" "}
                        {this.state.listSingleItemData.artistType == 0
                          ? config.currencyType
                          : config.currencyTypeSep}{" "}
                        Price
                      </label>
                      <input
                        type="text"
                        onKeyPress={(event) => {
                          if (!/^\d*[.]?\d{0,1}$/.test(event.key)) {
                            event.preventDefault();
                          }
                        }}
                        value={this.state.bidPrice}
                        name="Bid Amount"
                        onChange={(e) => {
                          this.changeBidPrice(e);
                        }}
                        className="form-control"
                        id="recipient-name"
                      />
                      <span style={{ color: "red" }}>
                        {this.state.priceError}
                      </span>
                    </div>
                  </form>
                </div>

                <div className="modal-footer">
                  <button
                    type="button"
                    style={{
                      width: "100%",
                      marginBottom: "-10px",
                      textAlign: "center",
                    }}
                    className="btn btn-reset-primary mb-3"
                    onClick={(e) => {
                      this.buyNft(e);
                    }}
                  >
                    Place Bid
                  </button>
                </div>
              </div>
            </div>
          </div>

          <Modal
            open={this.state.setOpen}
            onClose={this.onCloseModal.bind(this)}
            center
          >
            <div className="modal-header mt-4">
              <h5 className="modal-title" id="exampleModalLabel">
                By continuing you agree to our Terms & Conditions.
              </h5>
            </div>

            <div className="modal-body">
              <div className="genesischeck">
                <input
                  className="styled-checkbox"
                  id="styled-checkbox-1"
                  type="checkbox"
                  value={this.state.agreed}
                  onChange={this.handleCheckboxChange}
                />
                {/* <label htmlFor="styled-checkbox-1">I agree with <span>Terms and Conditions</span> and   <span> Privacy Policy </span></label> */}
                <label htmlFor="styled-checkbox-1">
                  Agree Terms & Conditions &nbsp; (
                  <a href="https://terms.artfungible.io/" target="_blank">
                    Click Here
                  </a>{" "}
                  &nbsp;to read)
                </label>
              </div>
            </div>

            <div className="modal-footer border-0 footerdiv">
              <button
                type="submit"
                disabled={!this.state.agreed}
                onClick={(e) => {
                  this.mint(e, this.state.itemData, this.state.nfttype);
                }}
                // onClick={this.loginAPIHit.bind(this, this.state.accountStore)}
                className="btn btn-buy-primary px-5"
              >
                Buy{" "}
              </button>
            </div>
          </Modal>

          <Footer1 />
        </div>
      </>
    );
  }
}
